import { render, staticRenderFns } from "./FiltersSection.vue?vue&type=template&id=59bab363&scoped=true"
import script from "./FiltersSection.vue?vue&type=script&lang=js"
export * from "./FiltersSection.vue?vue&type=script&lang=js"
import style0 from "./FiltersSection.vue?vue&type=style&index=0&id=59bab363&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bab363",
  null
  
)

export default component.exports